import http from '@/utils/http'
export const logout = data => http.post('kg-auth/oauth/token/json', 
data
)
export default {
    logout
}